import { Component, OnInit } from '@angular/core';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatHint, MatError } from '@angular/material/input';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepickerToggleIcon,
  MatDatepicker,
} from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-date',
  standalone: true,
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatIcon,
    MatDatepickerToggleIcon,
    MatDatepicker,
    MatHint,
    MatError,
  ],
})
export class DateComponent implements OnInit {
  field: Fields;
  group: UntypedFormGroup;
  requiredBool: boolean;
  minDate = new Date();
  maxDate: Date;

  ngOnInit() {
    // console.log("date----"+ JSON.stringify(this.field));
    if (this.field.value) this.field.value = new Date(this.field.value);
    const current_date = new Date();
    if (this.field.name == 'dob') {
      this.maxDate = new Date(current_date.setFullYear(current_date.getFullYear() - 18));
    }
  }
}
